import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'redux/store'
import { DownloadItem } from 'components/shared/DownloadPanel'
import {
  addDownload,
  updateDownload,
  removeDownload,
  setAutoDownload,
  clearDownloads,
} from '../DownloadsSlice'

const useDownloadsSlice = (): {
  downloads: DownloadItem[]
  autoDownload: boolean
  addDownloadItem: (download: DownloadItem) => void
  updateDownloadItem: (id: string, updates: Partial<DownloadItem>) => void
  removeDownloadItem: (id: string) => void
  setAutoDownloadEnabled: (enabled: boolean) => void
  clearAllDownloads: () => void
} => {
  const dispatch = useDispatch()
  const downloads = useSelector((state: RootState) => state.downloads.downloads)
  const autoDownload = useSelector((state: RootState) => state.downloads.autoDownload)

  const addDownloadItem = (download: DownloadItem) => {
    dispatch(addDownload(download))
  }

  const updateDownloadItem = (id: string, updates: Partial<DownloadItem>) => {
    dispatch(updateDownload({ id, updates }))
  }

  const removeDownloadItem = (id: string) => {
    dispatch(removeDownload(id))
  }

  const setAutoDownloadEnabled = (enabled: boolean) => {
    dispatch(setAutoDownload(enabled))
  }

  const clearAllDownloads = () => {
    dispatch(clearDownloads())
  }

  return {
    downloads,
    autoDownload,
    addDownloadItem,
    updateDownloadItem,
    removeDownloadItem,
    setAutoDownloadEnabled,
    clearAllDownloads,
  }
}

export default useDownloadsSlice
